import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from "react";
import BasePlayerEmbed from "./BasePlayerEmbed";
import loadYouTube from "../apiLoaders/loadYouTube";
import { canPublish } from "../utilities";
import { fireBuffer, fireEnd, firePause, firePlay } from "../analytics";

var YouTubePlayerEmbed = /*#__PURE__*/function (_Component) {
  _inherits(YouTubePlayerEmbed, _Component);

  var _super = _createSuper(YouTubePlayerEmbed);

  function YouTubePlayerEmbed() {
    var _this;

    _classCallCheck(this, YouTubePlayerEmbed);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleFrameReady", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(iframe) {
        var YT, player;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.props.analytics || canPublish())) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return loadYouTube();

              case 3:
                YT = _context.sent;
                player = new YT.Player(iframe);
                player.addEventListener("onStateChange", function (e) {
                  var videoMetadata = {
                    id: _this.props.videoId,
                    type: "YouTube",
                    title: player.getVideoData().title,
                    duration: player.getDuration(),
                    currentTime: player.getCurrentTime()
                  };

                  switch (e.data) {
                    case YT.PlayerState.PLAYING:
                      firePlay(videoMetadata, _this.props.analytics);
                      break;

                    case YT.PlayerState.BUFFERING:
                      fireBuffer(videoMetadata);
                      break;

                    case YT.PlayerState.PAUSED:
                      firePause(videoMetadata, _this.props.analytics);
                      break;

                    case YT.PlayerState.ENDED:
                      fireEnd(videoMetadata, _this.props.analytics);
                      break;
                  }
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    return _this;
  }

  _createClass(YouTubePlayerEmbed, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          videoId = _this$props.videoId,
          extra = _objectWithoutProperties(_this$props, ["videoId"]);

      var frameUrl = "https://www.youtube.com/embed/".concat(videoId, "?enablejsapi=1&autoplay=1&color=white&modestbranding=1&rel=0&showinfo=0&theme=light");
      return /*#__PURE__*/React.createElement(BasePlayerEmbed, _extends({
        src: frameUrl,
        onFrameReady: this.handleFrameReady
      }, extra));
    }
  }]);

  return YouTubePlayerEmbed;
}(Component);

export default YouTubePlayerEmbed;